import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';


export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .row-left {
    margin-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75em;
    line-height: 1.8em;
    margin-bottom: 0.5em;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6em; margin-bottom: 0em;`}
  }

  .row {

    .list-atv {
      margin-top: 1em !important;
    }

    .lateral {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      
      p {
        margin-left: 0.5em;
      }
    }

    .no-padding {
      padding: 0 !important;
    }

    .item {

      h6 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 0.8em;
        line-height: 1.8em;
        margin-bottom: 0em;
        color: ${Colors.Color4};
      }

      h3 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 1em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.Color7};
      }

      h5 {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.Color7};
      }

      p {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85em;
        line-height: 1.8em;
        color: ${Colors.color25};
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 1em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
    margin-bottom: 1.5em;
    border-radius: 0.4em;
    padding: 0em 1em 0em 1em !important;

    .content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75em;
        margin-bottom: 1.25em;

        .cod {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }

`;

export const ThisTicket = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ThisCab = styled.div`
  padding: 0.8em;
  border-radius: 0.85em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  width: 100%;
  min-height: 5.2em;
  position: relative;
  overflow: hidden;
  background: ${Colors.Color26};

  .card {
    display: flex;
    flex-direction: column;
    width: calc(100% - 10em);

    .top {
      display: flex;
      flex-direction: column;

      .content-top {
        line-height: 0.9em;
        display: flex;
        flex-direction: row;

        .card-cod {
          background: ${Colors.Color4};
          border-radius: 0.4em;
          padding: 0.2em 0.75em;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: fit-content;
          height: 1.5em;
  
          .cod {
            font-size: 0.75em;
            font-weight: 700;
            color: ${Colors.Color26};
          }
        }

        .card-titulo {
          background: ${Colors.Color2};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: fit-content;
          margin-left: 1em;
  
          .titulo {
            font-size: 0.75em;
            font-weight: 600;
            color: ${Colors.Color4};
          }
        }
      }
    }

    .infos {
      display: flex;
      flex-direction: row;
      margin-top: 1em;
      margin-bottom: 0.5em;

      .card-info {
        display: flex;
        flex-direction: row;
        margin-right: 2em;
        margin-left: 1em;
        width: fit-content;
        align-items: center;

        .status{
          background: #CE1E5D;
          border-radius: 0.15em;
          height: 0.5em;
          width: 0.5em;
        }

        .info {
          font-size: 0.7em;
          font-weight: 600;
          margin-left: 1em;
        }
      }
    }
  }
`;

export const ThisChat = styled.div`
  margin-bottom: 1.3em;
  padding: 2em;
  border-bottom-right-radius: 0.7em;
  border-bottom-left-radius: 0.7em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  width: 96%;
  min-height: 5.2em;
  position: relative;
  overflow: hidden;
  background: ${Colors.Color22};

  .chat{
    width: 100%;
    
    .msg{
      display: flex;
      width: 100%;
      margin-bottom: 2.5em;

      .avatar{
        display: flex;
        height: 3em;
        width: 3em;
        border-radius: 2em;
        justify-content: center;
        align-items: center;
        background: #293442;

        .icon-img{
          width: 100%;
        }
      }

      .triangulo{
        width: 0em; 
        height: 0em; 
        border-top: 11px solid transparent;
        border-bottom: 11px solid transparent;
        border-right: 11px solid #1B1B1C;
        margin-top: 1em;
        margin-left: 1.5em;
      }

      .triangulo-ativo{
        border-right: 11px solid ${Colors.Color4};
      }

      .balao{
        display: flex;
        padding: 1em;
        height: fit-content;
        width: 100%;
        border-radius: 0.8em;
        justify-content: flex-start;
        background: #1B1B1C;
        flex-direction: column;

        .cab{
          display: flex;
          justify-content: space-around;
          width: 100%;

          .user{
            display: flex;
            flex-direction: row;
            width: 100%;

            .nome{
              background: #141414;
              border-radius: 0.4em;
              padding: 0.2em 0.6em;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              width: fit-content;
              font-size: 0.75em;
              font-weight: 600;
              color: ${Colors.Color4};
            }
          }

          .aponta{
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-end;
          }

          p{
            text-align: left;
            max-width: 100%;
            font-weight: 500;
            font-size: 0.7em;
            line-height: 1.8em;
            color: #80868D;
            margin-left: 1em;
          }
        }

        .mensagem{
          margin: 1.5em 1.5em 1.5em 1em;

          .anexos{
            display: flex;
            flex-direction: row;

            .anexo{
              background: ${Colors.Color13};
              border-radius: 0.4em;
              padding: 0.5em 0.5em;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              width: fit-content;
              height: 2.5em;
              font-size: 0.75em;
              font-weight: 600;
              color: #80868D;
              margin-top: 2em;
              margin-right: 2em;

              .clipe{
                height: 2em;
                width: 2.2em;
                background: #1C1C1C;
                border-radius: 0.5em;
                margin-right: 1em;
                display: flex;
                justify-content: center;
                align-items: center;

                .icon-clipe{
                  height: 1.5em;
                  width: 1.7em;
                }
              }

              .texto-anexo{
                margin-right: 1em;
                font-size: 1em;
              }

              .icon-down{
                height: 1.7em;
                width: 1.7em;
                margin-left: 1em;
                margin-right: 0.5em; 
              }
            }
            
            .anexo-ativo{
              background: #5989C3;
  
              .clipe{
                background: #4878B2;
              }
            }
          }
        }
      }

      .balao-ativo{
        background:${Colors.Color4};

        .cab{
          .user{
            .nome{
              background: #5688C4;
              color: white;
            }
          }

          p{
            color: white;
          }
        }

        .mensagem{
          p{
            color: white;
          }
        }
      }
    }
  }
`;